import { JetView } from "webix-jet";

export default class TopBarView extends JetView {
	config() {
		const _ = this.app.getService("locale")._;
		this.Compact = this.getParam("compact");
		const bar = {
			view: "toolbar",
			paddingY: 9,
			paddingX: 12,
			css: "webix_um_toolbar",
			visibleBatch: "def",
			cols: [
				{
					view: "icon",
					icon: "webix_icon umi-menu",
					click: () => this.app.callEvent("menu:click", []),
					hidden: !this.Compact,
				},
				{ view: "label", label: _("User Manager") },
				{},
				{
					batch: "saving",
					view: "label",
					width: 30,
					label:
						"<span class='webix_icon webix_um_saving_icon umi-sync webix_spin'></span>",
				},
				{
					batch: "saved",
					cols: [
						{
							view: "label",
							label: _("Done"),
							width: 130,
							align: "right",
							css: "webix_um_saved_label",
						},
						{
							view: "label",
							width: 30,
							label:
								"<span class='webix_icon umi-check-circle webix_um_saved_icon'></span>",
						},
					],
				},
			],
		};

		return bar;
	}

	init() {
		this.app.getService("progress").handle(this.getRoot());
	}
}
